<template>
  <div>
    <div class="filter-bar mb-sm">
      <breadcrumb></breadcrumb>
      <div class="space"></div>
      <el-button size="small" type="primary" @click="onPre">预览</el-button>
      <el-button slot="reference" size="small" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>
    <div v-loading="loading" class="content-box">
      <div>
        <span class="label">学年：</span>
        <span> {{ groupInfo?.schoolYear }}</span>
      </div>
      <div>
        <span class="label">学期：</span>
        <span> {{ groupInfo?.schoolTerm | revertTerm }}</span>
      </div>
      <div>
        <span class="label">小组名称：</span>
        <span> {{ groupInfo?.groupName }}</span>
      </div>
      <div>
        <span class="label">类型：</span>
        <span> {{ groupInfo?.groupType | revertType }}</span>
      </div>
      <div>
        <h2 class="label">主持人：</h2>
        <span> {{ groupInfo?.leaderName }}</span>
      </div>
      <div style="flex-direction: column">
        <h2 class="label">成员列表：</h2>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="userName" label="姓名"> </el-table-column>
          <el-table-column prop="teacherInfoList" label="学科">
            <template slot-scope="scope">
              {{ scope.row.teacherInfoList | revertTeacherInfoList }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="userDutyDesc" label="学历">
          <template slot-scope="scope">
            {{ scope.row.teacherArchivesDTO?.educationDesc }}
          </template>
        </el-table-column> -->
          <el-table-column prop="teachingAge" label="教龄">
            <template slot-scope="scope">
              {{ scope.row.teacherArchivesDTO?.teachingAge }}
            </template>
          </el-table-column>
          <el-table-column prop="userDutyDesc" label="职称（务）">
            <template slot-scope="scope">
              {{ scope.row.teacherArchivesDTO?.academicTitlesDesc }}</template
            >
          </el-table-column>
          <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
              {{
                scope.row.teacherArchivesDTO?.remark &&
                JSON.parse(scope.row.teacherArchivesDTO.remark)
                  ?.researchProjectRemark
              }}</template
            >
          </el-table-column>
        </el-table>
      </div>
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">
            {{ groupInfo.groupType | revertType2 }}简介：
          </h2>
          <el-button
            v-if="form.introStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.introStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.introStatus"
            @click="updateProjectGroupInfo('intro')"
            >保存</el-button
          >
        </div>
        <el-input
          :readonly="form.introStatus"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          maxlength="450"
          show-word-limit
          style="width: 600px"
          v-model="groupInfo.intro"
        ></el-input>
      </div>
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">工作目标：</h2>
          <el-button
            v-if="form.targetStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.targetStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.targetStatus"
            @click="updateProjectGroupInfo('target')"
            >保存</el-button
          >
        </div>
        <el-input
          :readonly="form.targetStatus"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          maxlength="450"
          show-word-limit
          style="width: 600px"
          v-model="groupInfo.target"
        ></el-input>
      </div>
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">工作任务：</h2>
          <el-button
            v-if="form.taskStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.taskStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.taskStatus"
            @click="updateProjectGroupInfo('task')"
            >保存</el-button
          >
        </div>
        <el-input
          :readonly="form.taskStatus"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          maxlength="450"
          show-word-limit
          style="width: 600px"
          v-model="groupInfo.task"
        ></el-input>
      </div>
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">工作策略：</h2>
          <el-button
            v-if="form.planStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.planStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.planStatus"
            @click="updateProjectGroupInfo('plan')"
            >保存</el-button
          >
        </div>
        <el-input
          :readonly="form.planStatus"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          maxlength="450"
          show-word-limit
          style="width: 600px"
          v-model="groupInfo.plan"
        ></el-input>
      </div>
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">学期工作总结：</h2>
          <el-button
            v-if="form.summaryStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.summaryStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.summaryStatus"
            @click="updateProjectGroupInfo('summary')"
            >保存</el-button
          >
        </div>
        <el-input
          :readonly="form.summaryStatus"
          type="textarea"
          :autosize="{ minRows: 10, maxRows: 20 }"
          maxlength="1000"
          show-word-limit
          style="width: 600px"
          v-model="groupInfo.summary"
        ></el-input>
      </div>
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">日期：</h2>
          <el-button
            v-if="form.summaryDateStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.summaryDateStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.summaryDateStatus"
            @click="updateProjectGroupInfo('summaryDate')"
            >保存</el-button
          >
        </div>
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          :readonly="form.summaryDateStatus"
          v-model="groupInfo.summaryDate"
        ></el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { postData, postJson } from "../../../http/fetch";
import UploadLink from "@/components/upload/UploadLink.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

import { mapFileIcon, mapLinkIcon, lookFile, power } from "@/utils/index.js";
export default {
  components: {
    UploadLink,
    Breadcrumb,
  },
  filters: {
    revertTeacherInfoList(val) {
      return Array.from(new Set(val?.map((item) => item.disciplineName))).join(
        "，"
      );
    },
    revertTerm(val) {
      switch (val) {
        case 1:
          return "上学期";
        case 2:
          return "下学期";
      }
    },
    revertType(val) {
      switch (val) {
        case "sx":
          return "四薪";
        case "sp":
          return "三品";
        case "ef":
          return "二访";
      }
    },
    revertType2(val) {
      switch (val) {
        case "sx":
          return "工程";
        case "sp":
          return "品牌";
        case "ef":
          return "工作坊";
      }
    },
  },
  data() {
    return {
      groupCode: "",
      groupInfo: {
        plan: "",
        summary: "",
        intro: "",
        target: "",
        task: "",
        summaryDate: "",
      },
      loading: false,
      btnLoading: false,
      tableData: [],
      form: {
        planStatus: true,
        summaryStatus: true,
        introStatus: true,
        targetStatus: true,
        taskStatus: true,
        summaryDateStatus: true,
      },
    };
  },
  mounted() {
    if (sessionStorage.getItem("groupCode")) {
      this.groupCode = sessionStorage.getItem("groupCode");
      this.getDeatail(this.groupCode);
      this.getProjectGroupTeacherList(this.groupCode);
    }
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
  },
  methods: {
    mapFileIcon,
    mapLinkIcon,
    lookFile,
    power,
    onPre() {
      this.$router.push({
        name: "previewProjectHandbook",
        query: {
          groupCode: this.groupCode,
        },
      });
    },
    async updateProjectGroupInfo(type) {
      if (!this.groupInfo[type]) {
        this.$message.warning("请填写相关内容");
        return;
      } else {
        await postJson("/projectGroup/updateProjectGroupInfo", {
          groupCode: this.groupCode,
          id: this.groupInfo.id,
          operatorId: this.userInfo.userId,
          [type]: this.groupInfo[type],
        });
        this.form.introStatus = true;
        this.form.planStatus = true;
        this.form.summaryStatus = true;
        this.form.targetStatus = true;
        this.form.taskStatus = true;
        this.form.summaryDateStatus = true;
        this.$message.success("保存成功");
        this.getDeatail(this.groupCode);
      }
    },
    async getDeatail(groupCode) {
      this.loading = true;
      await postData("/projectGroup/getProjectGroupInfo", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupInfo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getProjectGroupTeacherList(groupCode) {
      this.loading = true;
      await postData("/projectGroup/getProjectGroupTeacherList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.tableData = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content-box {
  background-color: #fff;
  padding: 20px;
  > div {
    font-size: 16px;
    margin: 20px 0;
    display: flex;
    .label {
      min-width: 100px;
      font-size: 14px;
      font-weight: 600;
      color: #000000;
    }
  }
  ul {
    padding-left: 8px;
    // border: 1px solid rgb(241, 237, 237);
    // max-height: 357px;
    min-height: 40px;
    // overflow-y: auto;
    li {
      padding: 8px;
      margin-bottom: 15px;
      border: 1px solid rgb(224, 222, 222);
      border-radius: 5px;
      .big-icon {
        font-size: 35px;
        color: @color;
        // font-weight: 700;
      }
      .divider {
        margin-left: 20px;
        // border: 0.3px solid rgb(226, 220, 220);
        height: 38px;
      }
      h1 {
        font-size: 13px;
        padding-left: 10px;
      }

      h2 {
        margin-top: 2px;
        font-size: 12px;
        padding-left: 10px;
        color: @hui;
      }
      .look {
        margin-right: 60px;
      }
      .dow {
        margin-right: 100px;
      }
      .del {
        margin-right: 60px;
      }
    }
  }
}
</style>